var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-1"},[_c('v-card-text',{staticClass:"answer",on:{"click":function($event){return _vm.$emit('selectAnswer', _vm.answer)}}},[_vm._v(" "+_vm._s(_vm.answer.answer)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }